import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[appEfaAutoFocus]' })
export class EfaAutoFocus implements AfterViewInit {
  @Input() focus: boolean = false;
  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    if (this.focus) {
      this.elementRef.nativeElement.focus();
    }
  }
}
